import { useAppSelector } from "../../../store/hooks";
import { Employee, OperationalTask, WorkTask } from "../../../types/ganttChart";
import taskStyles from "../../../styles/ganttChart/tasks.module.css";
import ViolationChip from "../../UI/chips/ViolationChip";
import { useEffect, useState } from "react";
import { ReactComponent as WarningIcon } from "../../../assets/icons/warning_yellow.svg";
import DraggableGanttChartBlock from "../ganttChartBlocks/DraggableGanttChartBlock";

const VerticalOperationalTask = ({
  xPosition,
  yPosition,
  width,
  task,
  height,
  employee,
}: {
  xPosition: number;
  yPosition: number;
  width: number;
  task: WorkTask | OperationalTask;
  height: number;
  employee?: Employee;
}) => {
  const { verticalColumnWidth, selectedGanttChartTab } = useAppSelector(
    (state) => state.ganttChartSlice
  );
  const [isDraggingMatch, setIsDraggingMatch] = useState<boolean>(false);
  const { taskBeingDragged } = useAppSelector(
    (state) => state.dragAndDropSlice
  );
  useEffect(() => {
    if (taskBeingDragged) {
      setIsDraggingMatch(task.idTaskPlan === taskBeingDragged.task.idTaskPlan);
    } else {
      setIsDraggingMatch(false);
    }
  }, [taskBeingDragged]);

  return (
    <>
      {verticalColumnWidth && height && (
        <>
          {!isDraggingMatch && (
            <DraggableGanttChartBlock
              xPosition={xPosition}
              yPosition={yPosition}
              height={height}
              width={selectedGanttChartTab === "Custom" ? width * 0.7 : width}
              taskType="OPERATIONAL"
              task={task}
              employee={employee}
              isDraggingMatch={isDraggingMatch}
              backgroundColor={
                task.ganttChartPosition === 0
                  ? "var(--col-graph-second)"
                  : "var(--col-graph-second-2)"
              }
              border="4px solid var(--col-graph-second-2)"
              dragable={false}
            >
              <p className={taskStyles.verticalTaskText}>{task.description}</p>
              <div className="flex flex-wrap gap-[var(--spacing-xs)] absolute bottom-[var(--spacing-sm)] right-[var(--spacing-xs)] justify-end">
                {task.violations && task.violations.length > 0 && (
                  <ViolationChip />
                )}
                {((!task.endLocation.latitude && !task.endLocation.longitude) ||
                  (!task.startLocation.latitude &&
                    !task.startLocation.longitude)) && (
                  <WarningIcon height={14} width={14} />
                )}
              </div>
            </DraggableGanttChartBlock>
          )}
        </>
      )}
    </>
  );
};

export default VerticalOperationalTask;
